import { useState } from "react";
import { Form } from "react-bootstrap";
import { Settings,Users,MessageSquare,Mail,Plus,Smartphone,Clock,AlertTriangle,CheckCircle,Trash2 } from "lucide-react";
import TechnicalQues from "./technicalQues";
import CustomButton from "../../component/button";


const CHANNELS = [
  { key: 'email', label: 'Email', Icon: Mail, iconClass: 'text-secondary' },
  { key: 'whatsapp', label: 'WhatsApp', Icon: MessageSquare, iconClass: 'text-success' },
  { key: 'sms', label: 'SMS', Icon: Smartphone, iconClass: 'text-secondary' },
];


function ChatScreenConfig({config,setConfig}){

    const [activeTab, setActiveTab] = useState('general');
     


  const handleToggle = (key) => {
    setConfig(prev => ({
      ...prev,
      activities: { ...prev.activities, [key]: !prev.activities[key] }
    }));
  };


  const handleChannelToggle = (channel) => {
    setConfig(prev => ({
      ...prev,
      channels: prev.channels.includes(channel)
        ? prev.channels.filter(c => c !== channel)
        : [...prev.channels, channel]
    }));
  };

  const addQuestion = () => {
    setConfig(prev => ({
      ...prev,
      questions: [...prev.questions, { id: Date.now(), text: "", isClean: true, timerMinutes: prev.timerMinutes }]
    }));
  };

    return(
        <div>
      <div className="">
        <h4 className="heading-groupmain ">AI Chat Screening Configuration</h4>
      </div>
        <p className="text-muted text-sm m-0">Configure parameters and guardrails for the AI screening agent.</p>

      
      <ul className="nav-tabs-horizontal  border-b border-[var(--ui-border)]">
        <li className={`nav-item-h ${activeTab === 'general' ? 'active' : ''}`} onClick={() => setActiveTab('general')}>
          <Settings size={16} /> General Settings
        </li>
        {/* <li className={`nav-item-h ${activeTab === 'activities' ? 'active' : ''}`} onClick={() => setActiveTab('activities')}>
          <Users size={16} /> Activity Toggles
        </li> */}
        {
          config.activities.technical && (
            <li className={`nav-item-h ${activeTab === 'technical' ? 'active' : ''}`} onClick={() => setActiveTab('technical')}>
              <MessageSquare size={16} /> Technical Assessment
            </li>
          )
        }
        
      </ul>
 <div style={{borderBottom:'1px solid rgb(229, 231, 235)'}} className=" mb-4"></div>

      <div className="mt-4">
        {/* TAB: GENERAL SETTINGS */}
        {activeTab === 'general' && (
          <div className="form-flex-col max-w-2xl gap-4">
            <div 
            >
            
                              <Form.Label className="job_size">
                                Token Expiry (Days)
                              </Form.Label>
                              <Form.Control
                                value={config.expiryDays}
                                onChange={(e) => setConfig({...config, expiryDays: e.target.value})}
                                // value={details?.aboutCompany}
                                // disabled={adminData?.admin != "Admin"}
                                
                                className="textarea-placeholder-14"
                                min={1}
                                max={30}
                                
                              />
              <p className="text-xs text-gray-500 mt-1">Number of days the candidate has to initiate the chat before the link expires.</p>
                            </div>
           
           
            <div>
              <Form.Label className="job_size">
                 Delivery Channels
                </Form.Label>
              <div className="d-flex gap-3 flex-wrap ">
  {CHANNELS.map(({ key, label, Icon, iconClass }) => {
    const active = config.channels.includes(key);
    return (
      <label
        key={key}
        className={`channel-chip d-flex align-items-center gap-2 p-2 border rounded-3 mb-0 bg-light `}
      >
        <input
          type="checkbox"
          className="form-check-input m-0"
          checked={active}
          onChange={() => handleChannelToggle(key)}
        />
        <Icon size={16} className={iconClass} />
        <span>{label}</span>
      </label>
    );
  })}
</div>
    <div className="row g-3 mt-3" >
  {[
    { key: 'interest', title: "1. Continued Interest", desc: "Verify if the candidate is still interested in the role." },
    { key: 'requirements', title: "2. Verify Key Requirements", desc: "Check non-negotiables (location, salary, visa status)." },
    { key: 'technical', title: "3. Technical Topic", desc: "Ask specific technical questions from the bank." },
    // { key: 'behavior', title: "4. Behaviour Check", desc: "Conduct a brief situational judgment test." },
    { key: 'logistics', title: "4. Next-Step Logistics", desc: "Collect availability for the next interview round." },
    { key: 'referrals', title: "5. Optional Referrals", desc: "Ask if they know anyone else suitable for LYWO." }
  ].map(act => (
    <div className="col-12 col-md-6" key={act.key}>
      <div className="card h-100 border shadow-sm activity-card" style={{padding:'2px',backgroundColor:'white'}}>
        <div className="card-body d-flex align-items-center gap-3">
          <label className="custom-switch-wrap m-0">
            <input
              type="checkbox"
              className="switch-input"
              checked={config.activities[act.key]}
              onChange={() => handleToggle(act.key)}
            />
            <span className="switch-slider"></span>
          </label>
          <div>
            <label className="job_size form-label">{act.title}</label>
            <span className="small text-muted mb-0" style={{ fontSize: '.75rem' }}>{act.desc}</span>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>

            </div>
          </div>
        )}


        {/* TAB: ACTIVITY TOGGLES */}
        {/* {activeTab === 'activities' && (
          <div className="row g-3" >
  {[
    { key: 'interest', title: "1. Continued Interest", desc: "Verify if the candidate is still interested in the role." },
    { key: 'requirements', title: "2. Verify Key Requirements", desc: "Check non-negotiables (location, salary, visa status)." },
    { key: 'technical', title: "3. Technical Topic", desc: "Ask specific technical questions from the bank." },
    // { key: 'behavior', title: "4. Behaviour Check", desc: "Conduct a brief situational judgment test." },
    { key: 'logistics', title: "4. Next-Step Logistics", desc: "Collect availability for the next interview round." },
    { key: 'referrals', title: "5. Optional Referrals", desc: "Ask if they know anyone else suitable for LYWO." }
  ].map(act => (
    <div className="col-12 col-md-6" key={act.key}>
      <div className="card h-100 border shadow-sm activity-card" style={{padding:'2px',backgroundColor:'white'}}>
        <div className="card-body d-flex align-items-center gap-3">
          <label className="custom-switch-wrap m-0">
            <input
              type="checkbox"
              className="switch-input"
              checked={config.activities[act.key]}
              onChange={() => handleToggle(act.key)}
            />
            <span className="switch-slider"></span>
          </label>
          <div>
            <h4 className="fw-bold mb-1" style={{ fontSize: '.875rem' }}>{act.title}</h4>
            <p className="text-secondary mb-0" style={{ fontSize: '.75rem' }}>{act.desc}</p>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>
        )} */}


        {/* TAB: TECHNICAL ASSESSMENT */}
        {activeTab === 'technical' && (<>
        <TechnicalQues
        config={config}
        setConfig={setConfig}
        addQuestion={addQuestion}
        />

          </>
        )}
      </div>

      {/* <div style={{borderBottom:'1px solid rgb(229, 231, 235)'}} className="mt-4"></div>
     
      <div className="mt-3 d-flex justify-content-end gap-3">
        <CustomButton 
        title='Cancel'
        buttonType='secondary'
        handleClick={()=>{}}
        />
        <CustomButton
        title="Save Configuration"
        handleClick={()=>{}}
        />
      </div> */}
    </div>
    )

}

export default ChatScreenConfig